import { useContext, useEffect, useState } from "react";
import ContactInformationForm from "../../Common/Forms/ContactInformationForm/ContactInformationForm.tsx";
import { AuthContext } from "../../../contexts/AuthContext";
import { apiUserDetailsRetrieve, apiUserDetailsUpdate } from "../../../sdk";

import promptStyle from "../prompt.module.css";
import { ContactInformation } from "../../../sdkStructs.ts";

function checkComplete(contactInfo: ContactInformation) {
  return contactInfo.Name && contactInfo.Email && contactInfo.PhoneNumber && contactInfo.Company;
}

interface Props {
  advance: () => void,
}
function InfoPrompt({ advance }: Readonly<Props>) {
  const token = useContext(AuthContext).token;

  const [contactInfo, setContactInfo] = useState<ContactInformation>();

  useEffect(() => {
    async function load() {
      const response = await apiUserDetailsRetrieve(token);
      setContactInfo(response.data);
    }

    if (token) load();
  }, [token]);

  useEffect(() => {
    if (!contactInfo) return;

    if (checkComplete(contactInfo)) {
      console.log("Solved Contact Information Form");
      advance();
    }
  }, [contactInfo, advance]);

  async function changeContactInfo(data: ContactInformation) {
    const newData = { ...data, Phone_Number: data.PhoneNumber };
    await apiUserDetailsUpdate(token, newData);
    setContactInfo(data);
  }

  if (!contactInfo || checkComplete(contactInfo)) return;

  return (
    <div className={promptStyle.promptWrapper}>
      <div className={promptStyle.infoColumn}>
        <h2 className={promptStyle.title}>One more step ... </h2>
        <p>
          Before creating a pentest you should first enter your{" "}
          <span className={promptStyle.blueText}>Contact Information</span>.
          <br />
          You can later edit the <span className={promptStyle.blueText}>Template</span> for your report, but the {" "}
          <span className={promptStyle.blueText}>default values</span> for these fields will be sourced from your
          account.
        </p>
      </div>
      <div className={promptStyle.promptForm}>
        <ContactInformationForm formDefault={contactInfo} submit={changeContactInfo} />
    </div>
    </div >
  );
}

export default InfoPrompt;
